import { exists as translationExists, t } from 'i18next'

import { isString } from './isString'
import { getLocalizedSchemaAttributes } from './schemaLocalization'
import { TableColumn } from '@/Components/EntityTable/types'
import { SchemaAttributes, SchemaLabel } from '@/Data/types'

/**
 * gets the effectively available table columns and updates their title if required
 * @param allColumns all available table columns
 * @param schemaAttributes the schema attributes definitions
 * @param availableLabels the available labels
 * @param labels the currently selected labels
 * @returns an array containing the table columns to be rendered
 */
export const getTableColumns = (
  allColumns: TableColumn[],
  schemaAttributes?: SchemaAttributes,
  availableLabels?: SchemaLabel[],
  labels?: string,
): TableColumn[] => {
  const localizedSchemaAttributes =
    getLocalizedSchemaAttributes(schemaAttributes)

  const columns = allColumns.filter((col) => {
    if (col.accessor !== 'labels') {
      return true
    } else {
      return availableLabels && availableLabels.length > 0 && isString(labels)
    }
  })

  return columns.map((col) => {
    const accessor = (col.accessor || '').trim()

    const translationKeys = (
      col.cell && col.titleKey ? [`tables.headers.${col.titleKey}`] : []
    ) as string[]

    const existingTranslationKey = translationKeys.find((key) =>
      translationExists(key),
    )
    const translatedTitle = existingTranslationKey
      ? t(existingTranslationKey)
      : undefined

    const schemaTitle = accessor
      ? localizedSchemaAttributes?.[accessor]?.title
      : undefined

    return {
      ...col,
      title: translatedTitle || schemaTitle || col.title,
    }
  })
}
